export const TRAINING_ASSET_TYPE_ID = 104;
export const OTHER_SUBJECT_ID = 94;
